export default "__VITE_ASSET__CSZnAPtA__"